import React from "react";
class AccordionContentElement extends React.Component {
}
export default AccordionContentElement;
